<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submitLocal)">
        <CRow>
            <CCustomSelect
                sm="12" md="4"
                v-model="conversion.status"
                :options="conversionEditableStatusOption"
                vid="status"
                required
                rules="required"
                :name="$t('conversion.status')"
            />
            <CCustomInput
                v-model="conversion.amount"
                sm="12" md="8"
                vid="amount"
                :name="$t('conversion.amount')"
                rules="required"
                type="number"
                required
                ltr
            />
            <CCustomInput
                v-if="conversion.type === ConversionType.SALE"
                v-model="conversion.external_id"
                sm="12" md="6"
                vid="external_id"
                :name="$t('conversion.external_id')"
                :rules="{required: conversion.type === ConversionType.SALE}"
                :required="conversion.type === ConversionType.SALE"
                ltr
            />

            <CCustomInput
                v-if="conversion.type === ConversionType.SALE"
                v-model="conversion.coupon"
                sm="12" md="6"
                vid="coupon"
                :name="$t('coupon._')"
                ltr
            />
        </CRow>

        <CRow v-if="conversion.products" class="mt-3">
            <CDataTable
                class="col-12 px-0"
                :items="conversion.products"
                :fields="$dataTableFieldsMaker(productsFields)"
            >
                <template #pid="{item}">
                    <td>
                        {{ item.pid || '-' }}
                    </td>
                </template>

                <template #name="{item}">
                    <td>
                        {{ item.sku || item.name }}
                    </td>
                </template>

                <template #unitPrice="{item}">
                    <td class="ltr">
                        <CInput addInputClasses="small" type="number" v-model="item.unit_price" />
                    </td>
                </template>

                <template #quantity="{item}">
                    <td>
                        <CInput addInputClasses="small" type="number" v-model="item.quantity" />
                    </td>
                </template>

                <template #totalPrice="{item}">
                    <td class="ltr">
                        <CInput addInputClasses="small" type="number" v-model="item.total_price" />
                    </td>
                </template>
            </CDataTable>
        </CRow>

        <div v-if="conversion.version === 1">
            <div class="border-bottom pb-1 mb-3 h5">
                {{ $t('commission.plural') }}
            </div>
            <CRow v-for="(commission, index) in conversion.commissions" v-bind:key="index">
                <CCustomInput
                    :prepend="commission.name"
                    v-model="commission.sub_amount"
                    sm="12" md="6"
                    name="ساب کمیسیون"
                    :vid="'commission['+index+'].sub_amount'"
                    rules="required|double"
                    ltr
                />
            </CRow>
        </div>

        <CButton :disabled="invalid" type="submit"  color="primary" class="px-4">{{ $t('submit') }}</CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { conversionEditableStatusOption } from '@/common/data'
import { ConversionType } from '@/constants'
import { productsFields } from './fields'

export default {
    name: 'Form',

    props: {
        submit: {
            type: Function,
            default() {}
        },
        conversion: {
            default() {
                return {
                    external_id: '',
                    amount: '',
                    status: '',
                    commissions: [],
                    version: 1,
                    coupon: '',
                    products: [
                        /*
                        name or sku
                        unit_price
                        quantity
                        total_price
                        pid
                        */
                    ],
                }
            },
            type: Object
        }
    },
    data() {
        return {
            conversionEditableStatusOption,
            ConversionType,
            productsFields,
        }
    },
    methods: {
        submitLocal() {
            const data = {
                id: this.conversion.id,
                order_id: this.conversion.external_id,
                external_id: this.conversion.external_id,
                amount: this.conversion.amount,
                status: this.conversion.status,
                coupon: this.conversion.coupon,
                products: this.conversion.products,
                commissions: this.conversion.commissions,
                recalculate: true,
            }

            this.submit(data)
        }
    }
}
</script>